import HorizontalExample from "./examples/Horizontal.Example";
import VerticalExample from "./examples/Vertical.Example";
import TrapZoneExample from "./examples/TrapZone.Example";
import FocusOnMountExample from "./examples/FocusOnMount.Example";

export default [
    {
        title: "Horizontal example",
        component: HorizontalExample,
        code: require("!raw-loader!./examples/Horizontal.Example.tsx")
    },
    {
        title: "Vertical (circular) example",
        component: VerticalExample,
        code: require("!raw-loader!./examples/Vertical.Example.tsx")
    },
    {
        title: "Trap Zone example",
        component: TrapZoneExample,
        code: require("!raw-loader!./examples/TrapZone.Example.tsx")
    },
    {
        title: "Focus On Mount example",
        component: FocusOnMountExample,
        code: require("!raw-loader!./examples/FocusOnMount.Example.tsx")
    }
];
